module.exports = __webpack_public_path__ + "static/img/progress_bg2.883c9375.png";